import { useContext } from 'react';

import { ResponseDto } from '@r1-frontend/api-domru/dadata/v1/address/check/dto/ResponseDto';

import { Ctx } from '@r1-frontend/unified-address-form/Ctx';

import Button, { TButtonProps } from '@r1-frontend/ui-react/components/buttons/button';

import submit from '../actions/submit';
import { useCtxDispatch, useCtxSelector } from '../hooks';
import { TFailedCheckResult } from '../reducer/initialState';
import getSubmitButtonProps from '../selectors/getSubmitButtonProps';

export type TSubmitButtonResult = (ResponseDto | TFailedCheckResult) & {
    address: {
        value: string,
        flat: string,
        unifiedHouseId?: number,
        connectionCost?: number,
    },
};

type TSubmitButtonProps = Omit<TButtonProps, 'onClick'> & {
    onClick: (result: TSubmitButtonResult) => void,
}

const SubmitButton = ({ onClick, ...buttonProps }: TSubmitButtonProps): JSX.Element => {
    const { analytics } = useContext(Ctx);
    const dispatch = useCtxDispatch();
    const { disabled } = useCtxSelector(getSubmitButtonProps);

    const handleSubmit = () => {
        dispatch(submit(onClick, analytics));
    };

    // @ts-ignore TS2769: No overload matches this call.
    return <Button {...buttonProps} onClick={handleSubmit} disabled={disabled}/>;
};

export default SubmitButton;
